import { Api } from '../lib'

const TYPE = {
  get_categories: 'GET_CATEGORIES',
  get_products: 'GET_PRODUCTS'
}

const api = new Api()

const fetchCategories = () => dispatch => api
  .get('categories')
  .then( cat => dispatch({type: TYPE.get_categories, payload: cat.data}) )

const fetchProductsInCategory = ({query}) => (dispatch, getState) => api
  .get('products', {
    query
  })
  .then( prod => dispatch({type: TYPE.get_products, payload: prod.data}) )

export default {
  TYPE,
  fetchCategories,
  fetchProductsInCategory
}
